import { render, staticRenderFns } from "./ModalPago.vue?vue&type=template&id=796b7e0b&"
import script from "./ModalPago.vue?vue&type=script&lang=js&"
export * from "./ModalPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports